var e = {}, o = {
  get exports() {
    return e;
  },
  set exports(r) {
    e = r;
  }
};
export {
  o as __module,
  e as exports
};
//# sourceMappingURL=loadYouTubeIframeApi.mjs.map
